<template>
  <div class="about">
    <v-header />
    <v-sidebar />
    <div class="content-box" :class="{ 'content-collapse': collapse }">
      <div class="contente">
        <section class="app-main">
          <transition name="fade-transform" mode="out-in">
              <router-view  />
          </transition>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import vHeader from "../layout/Header.vue"
import vSidebar from "../layout/Sidebar.vue";
export default {
  components: {
    vHeader,
    vSidebar,
  },
  data() {
    return {}
  },
  computed: {
    collapse() {
      return this.$store.state.collapse
    }
  },
  methods: {},
  created() { },
  mounted() { }
}
</script>

<style>
.about{
  height: 100vh;
}
.app-main {
  /* 50= navbar  50  */
  /* min-height: calc(100vh - 50px); */
  width: 100%;
  position: relative;
  overflow: hidden;
}
</style>
